<script setup lang="ts">
withDefaults(
    defineProps<{
        disabled?: boolean;
        error?: boolean;
    }>(),
    {
        error: false,
    },
);

const modelValue = defineModel<boolean | 'indeterminate'>({
    required: true,
});
</script>

<template>
    <div class="flex flex-col gap-2.5">
        <label
            class="relative flex flex-row gap-3"
            :class="[
                disabled ? 'cursor-not-allowed opacity-40' : 'cursor-pointer',
            ]"
        >
            <CheckboxRoot
                v-model="modelValue"
                :disabled
                :class="{
                    'border-2 border-red-700': error && !modelValue,
                    'border border-gray-900': !error,
                    'bg-gray-900': modelValue && !disabled,
                }"
                class="mt-0.5 flex h-5 !min-w-5 items-center justify-center rounded transition-colors focus:outline-2 focus:outline-offset-4 focus:outline-gray-900"
            >
                <CheckboxIndicator>
                    <JamBaseIcon
                        class="justify-center text-white"
                        :icon-name="
                            modelValue === 'indeterminate'
                                ? 'indeterminate'
                                : 'checkbox'
                        "
                        size="medium"
                    />
                </CheckboxIndicator>
            </CheckboxRoot>
            <BaseText><slot /></BaseText>
        </label>
    </div>
</template>
